import { render, staticRenderFns } from "./signupForm.vue?vue&type=template&id=2b7e4939&"
import script from "./signupForm.vue?vue&type=script&lang=js&"
export * from "./signupForm.vue?vue&type=script&lang=js&"
import style0 from "./signupForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "signupForm.vue"
export default component.exports